import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { AppHelper } from "../appHelper";
import { AppBaseProps, CommonApp, Context, Metadata } from "../core/components/commonApp";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { HTTPService } from "../core/util/httpManager";
import React from "react";

interface StockSearchResult {
    artNr: number;
    chargenNr: string;
    serienNr: string;
    lagerId: number;
    lagerplatzId: number;

    maxAmount: number;
    amount: number;

    article: any;
}

export const openStockSearch = async () => {
    return new Promise<StockSearchResult[]>(async (resolve) => {
        const data = await openSearch();
        if (data.length == 0) {
            resolve([]);
            return;
        }
        const props: AmountGridWrapperProps = {
            metadata: {
                tabs: [
                    {
                        component: "renderGrid()",
                        title: "",
                        type: "tab_with_module"
                    } as any
                ],
                menuDataSource: [
                    {
                        floating: true,
                        floatingColor: "#cc3467",
                        icon: "arrow-turn-right",
                        onClick: "takeOver()",
                        show: true,
                        text: Helper.getTranslation("WebSMS.Warehouse.TakeOver")
                    }
                ]
            },
            context: {

            },
            dataSources: {},
            entity: {
                IsNew: false,
                IsWatchable: false,
                IsWatched: false,
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                IndividualFields: {}

            },
            isWindow: true,
            title: "",
            rawData: data,
            takeOver: (data) => {
                resolve(data)
            }
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.mountContent(AmountGridWrapper, props);
        });
        sheet.bind(SheetEventType.Close, () => {
            resolve([])
        });
    });
}

const openSearch = () => {
    return new Promise<any[]>((resolve) => {
        const sheet = General.Sheet.Manager.createSheetWithUrl("DynamicSearch/Window/Stock?multi=true&displayPattern=[[article]]([[chargennr]]/[[seriennr]]) in [[storagespace]]&cus_restricted=true", null, null, true);
        sheet.bind(SheetEventType.ItemsSelected, (data: { data: any[] }) => {
            resolve(data.data)
        })
    })
}
interface AmountGridWrapperProps extends AppBaseProps {
    rawData: any[];
    takeOver: (data: StockSearchResult[]) => void;
}
interface AmountGridWrapperState {
    gridData: StockSearchResult[];
}
class AmountGridWrapper extends React.Component<AmountGridWrapperProps, AmountGridWrapperState>{
    private common = new AppHelper();
    private LIMIT_AMOUNT = true;

    constructor(props: AmountGridWrapperProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.state = {
            gridData: props.rawData.map((item) => {
                return {
                    article: item,
                    maxAmount: item.amount,
                    amount: item.amount,
                    artNr: item.artnr,
                    chargenNr: item.chargennr,
                    serienNr: item.seriennr,
                    lagerId: item.warehouseid,
                    lagerplatzId: item.storagespaceid
                }
            })
        }
    }

    takeOver = () => {
        this.props.takeOver(this.state.gridData)
        this.common.sheetWrapper.hide()
    }

    renderGrid = () => {
        return <AmountGrid gridData={this.state.gridData} onDataChange={(gridData) => { this.setState({ gridData: gridData }) }} limitAmount={this.LIMIT_AMOUNT} />
    }

    componentDidMount() {
        this.common.updateSheetTitle("Mengen bestimmen");
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: () => { this.common.setEntityDirtyState(false); } });
        return <CommonApp {...props} />;
    }
}
interface AmountGridProps {
    gridData: StockSearchResult[];
    limitAmount: boolean;
    onDataChange: (gridData: StockSearchResult[]) => void;
    
}
class AmountGrid extends React.Component<AmountGridProps, any>{
    private gridOptions: kendo.ui.GridOptions;

    constructor(props: AmountGridProps) {
        super(props)
        this.initApp();
    }

    private initApp = () => {
        this.gridOptions = {
            sortable: false,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "artNr",
                    title: Helper.getTranslation("BrowserTitle.Parts.Available") + "/" + Helper.getTranslation("WebSMS.PartsList.ArticleNo"),
                    template: (item: StockSearchResult) => {
                        const text = `${item.article.article} (${item.article.articlenumber})`
                        return `<div class="truncate" title="${text}">${text}</div>`
                    },
                },
                //{
                //    field: "chargenNr/serienNr",
                //    title: Helper.getTranslation("Field.Material.chargennr") + "/" + Helper.getTranslation("Field.Material.seriennr"),
                //    template: (item: StockSearchResult) => {
                //        const text = `${item.article.chargennr} / ${item.article.seriennr}`
                //        return `<div class="truncate" title="${text}">${text}</div>`
                //    },
                //},
                {
                    field: "lagerplatzId",
                    title: Helper.getTranslation("WebSMS.Warehouse") + "/" + Helper.getTranslation("WebSMS.Warehouse.StorageSpace"),
                    template: (item: StockSearchResult) => {
                        const text = `${item.article.warehouse} / ${item.article.storagespace}`
                        return `<div class="truncate" title="${text}">${text}</div>`
                    },
                },
                {
                    field: "amount",
                    title: Helper.getTranslation("WebSMS.PartsList.ArtAmount"),
                    template: (item: StockSearchResult) => {
                        const innerHTML = this.props.limitAmount ? `<div style="font-size:25px; margin: 0 5px">/${item.maxAmount}</div>` : null;
                        return `<div style="display: flex"><input/>${innerHTML}</div>`
                    },
                    width: "250px"
                }

            ]
        }
    }

    private onDataBound = (event) => {
        const data = event.sender.dataSource.view();
        for (let i = 0; i < data.length; i++) {
            const item: StockSearchResult = data[i];
            const input = event.sender.tbody.find(`tr[data-uid='${data[i].uid}'] input`);
            $(input).kendoNumericTextBox({
                spinners: true,
                min: 0,
                max: this.props.limitAmount ? item.maxAmount : null,
                value: item.amount,
                change: (ev) => {
                    const value = ev.sender.value();
                    const gridData = this.props.gridData;
                    const index = gridData.findIndex(i => i.artNr == item.artNr && i.lagerplatzId == item.lagerplatzId && i.chargenNr == item.chargenNr && i.serienNr == item.serienNr);
                    gridData[index].amount = value;
                    this.props.onDataChange(gridData);
                }
            }).data("kendoNumericTextBox");

        }
    }

    render() {
        return (
            <div>
                <Grid
                    data={this.props.gridData}
                    options={this.gridOptions}
                    id={`stocks_amount`}
                    onDataBound={this.onDataBound}
                />
            </div>
        );
    }
}